import Form from 'mobx-react-form';
import plugins from './plugins';


const fields = {
    tenant: {
        label: 'Tenant Id',
        rules: 'required|string',
    },
};

class TeamsForm extends Form {
    constructor(setup, options) {
        super({ fields, ...setup }, { plugins, ...options });
    }
}

export default TeamsForm;
